import { axiosInstance } from "./config";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useDocumentTypes = () => {
  return useQuery({
    queryKey: ["document-types"],
    queryFn: () => axiosInstance.get(`document-types`),
  });
};

export const useAddTenderDocument = (tenderId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) =>
      axiosInstance.post(`tenders/${tenderId}/documents`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["tender-detail", tenderId],
      });
    },
  });
};

export const useAddQuotationDocument = (quotationId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: any) =>
      axiosInstance.post(`quotations/${quotationId}/documents`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["quotation-detail", quotationId],
      });
    },
  });
};
